export default __webpack_public_path__ + "static/media/hot-3.f98fbfac.png";